import { fetchApi } from "./FetchAPI";
import { getUserToken } from "./Utils";
import {
  adminUsersApi,
  adminImportApi,
  adminAuditLogsApi,
  adminNotificationTemplatesApi,
  adminNotificationCampaignsApi,
} from "../ENV";

function adminHeaders(extra = {}) {
  return new Headers({
    "Content-Type": "application/json",
    "x-access-token": getUserToken() || "",
    ...extra,
  });
}

export async function getAdminUsers({ phone = "", name = "", user_type = "", page = 1, page_size = 20 } = {}) {
  const params = { page, page_size };
  if (phone) params.phone = phone;
  if (name) params.name = name;
  if (user_type) params.user_type = user_type;
  return fetchApi(adminUsersApi, "GET", {}, adminHeaders(), params);
}

export async function createAdminUser(payload, idempotencyKey) {
  const headers = adminHeaders(idempotencyKey ? { "Idempotency-Key": idempotencyKey } : {});
  return fetchApi(adminUsersApi, "POST", JSON.stringify(payload), headers);
}

export async function updateAdminUser(userId, payload) {
  return fetchApi(
    `${adminUsersApi}/${userId}`,
    "PATCH",
    JSON.stringify(payload),
    adminHeaders()
  );
}

export async function importAdminUsers(file, dryRun = true, { user_type = "", approach = "" } = {}) {
  const formData = new FormData();
  formData.append("file", file, file.name);
  if (user_type) formData.append("user_type", user_type);
  if (approach) formData.append("approach", approach);
  const token = getUserToken() || "";
  try {
    const response = await fetch(
      `${adminImportApi}?dry_run=${dryRun ? "true" : "false"}`,
      {
        method: "POST",
        headers: { "x-access-token": token },
        body: formData,
      }
    );
    const contentType = response.headers.get("Content-Type") || "";
    const data = contentType.includes("application/json")
      ? await response.json()
      : await response.text();
    return { status: response.status, data };
  } catch (e) {
    return { error: e.message };
  }
}

export async function getAuditLogs({ user_id = "", action = "", page = 1, limit = 20 } = {}) {
  const params = { page, limit };
  if (user_id) params.user_id = user_id;
  if (action) params.action = action;
  return fetchApi(adminAuditLogsApi, "GET", {}, adminHeaders(), params);
}

export async function getNotificationTemplates() {
  return fetchApi(adminNotificationTemplatesApi, "GET", {}, adminHeaders());
}

export async function sendNotificationCampaign(payload) {
  return fetchApi(
    adminNotificationCampaignsApi,
    "POST",
    JSON.stringify(payload),
    adminHeaders()
  );
}

export async function createNotificationTemplate(payload) {
  return fetchApi(
    adminNotificationTemplatesApi,
    "POST",
    JSON.stringify(payload),
    adminHeaders()
  );
}
